import React from "react";

export const Compare = () => {
  return (
    <div id="compare">
      <div className="container">
        <div className="section-title">
          <h2 className="text-center">Why Choose Effortless Test</h2>
          <ul className="feature-list">
            <li style={{marginTop: 30}}>
              <h4>🚀 Effortless Experience</h4>
              <p>
                EffortlessTest transforms test creation into a seamless process. 
                You can write a test with just one mouse click — yes, literally one click.
              </p>
            </li>
            <li style={{marginTop: 30}}>
              <h4>🧠 Zero Learning Curve</h4>
              <p>
                The intuitive UI and interactive JSON interface make it simple to use right away. 
                There's virtually no learning curve — anyone can get started immediately.
              </p>
            </li>
            <li style={{marginTop: 30}}>
              <h4>🖱️ One-Click Assertions</h4>
              <p>
                Generate assertions by simply clicking fields in the response body. 
                No other tool offers this level of interactivity and ease.
              </p>
            </li>
            <li style={{marginTop: 30}}>
              <h4>🔧 Hassle-Free CI Test Execution</h4>
              <p>
                Tests written during development can be executed in your CI pipeline with zero setup overhead. 
                No exporting or fiddling with config files — just hit "Save" to upload and run.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
